import React, { useMemo, useRef } from 'react'
import { CKEditor, CKEditorEventHandler } from 'ckeditor4-react'

interface EditorProps {
  editorContent: string
  setEditorContent: (content: string) => void
  // eslint-disable-next-line react/require-default-props
  className?: string
  // eslint-disable-next-line react/require-default-props
  name?: string
  // Merged over the defaults. Keep the object referentially stable: a new config recreates the editor.
  // eslint-disable-next-line react/require-default-props
  config?: Record<string, unknown>
  // eslint-disable-next-line react/require-default-props
  onPaste?: CKEditorEventHandler<'paste'>
  // eslint-disable-next-line react/require-default-props
  readOnly?: boolean
  // eslint-disable-next-line react/require-default-props
  onInstanceReady?: CKEditorEventHandler<'instanceReady'>
}

const defaultConfig = {
  height: 'inherit',
  resize_enabled: false,
  versionCheck: false,
}
export default function Editor({
  editorContent,
  setEditorContent,
  className = 'settings__container__editor',
  name = 'settings-editor',
  config,
  onPaste,
  readOnly = false,
  onInstanceReady,
}: EditorProps) {
  const mergedConfig = useMemo(() => ({ ...defaultConfig, ...config }), [config])
  // ckeditor4-react keeps the handlers of the first render, so the latest one is reached through a ref.
  const onPasteRef = useRef(onPaste)
  onPasteRef.current = onPaste
  const onInstanceReadyRef = useRef(onInstanceReady)
  onInstanceReadyRef.current = onInstanceReady

  return (
    <div className={className}>
      <CKEditor
        config={mergedConfig}
        name={name}
        onGetData={() => editorContent}
        initData={editorContent}
        onChange={({ editor }) => {
          setEditorContent(editor.getData())
        }}
        onPaste={(evt) => onPasteRef.current?.(evt)}
        readOnly={readOnly}
        onInstanceReady={(evt) => onInstanceReadyRef.current?.(evt)}
      />
    </div>
  )
}
